export default __webpack_public_path__ + "static/media/029-javascript.b41852a0.svg";